// import type {RequiredOptions} from "qr-code-styling/lib/core/QROptions";
//@ts-ignore
// import type QRCanvas from "qr-code-styling/lib/core/QRCanvas";
// import type QRSVG from "qr-code-styling/lib/core/QRSVG";
//@ts-ignore
// import type {DownloadOptions, Extension, Options, QRCode} from "qr-code-styling/lib/types";
type RequiredOptions = any;
type DownloadOptions = any;
type Extension = any;
type Options = any;
type QRCode = any;
type QRSVG = any;
type QRCanvas = any;
import JSX, {JSXElement} from "./react.js";
import {JSON5} from "./json5.js";
import RefObject = JSX.RefObject;
import {getAcceptHeader} from "../config.js";


declare global {
    const login: string;
}

export class YummyServerError extends Error {
    public readonly code: number;

    constructor(errorMsg: string, errorCode: number = 0, public readonly title: string = 'Ошибка', public readonly name: string = 'Undefined Error', public readonly subErrorCode?: number | null) {
        super(errorMsg);
        this.code = errorCode;
    }

    toString() {
        return this.message;
    }
}

export class YummyUploadImageError extends YummyServerError {
    public data: any;

    constructor(text: string, data: any) {
        super(text, 1001);
        this.data = data;
    }
}

export interface ServerResponse {
    error?: string;
    error_code?: number;
    error_title?: string;
    error_name?: string;
    sub_error_code?: number;
}

export enum ErrorCode {
    Undefined = 0,
    NotAuthorizedException = 1,
    PermissionDeniedException = 2,
    ArgumentsError = 3,
    NotFountError = 4,
    CaptchaError = 5,
    FloodControlException = 6,
    InvalidPasswordException = 7,
    FormDataError = 8
}

export function isChatOpen(toggleState: boolean = false): boolean {
    const $el = $('#chat-toggle-button');
    if (toggleState) $el.toggleClass('selected');
    return $el.hasClass('selected');
}

export function askWhyBanUser(nickName: string, block = true, where = ' в глобальном чате'): Promise<[number, string]> {
    return new Promise<[number, string]>((resolve, reject) => {
        const [days, hours, minutes, seconds] = [{}, {}, {}, {}] as RefObject<HTMLInputElement>[];
        const dialog = (
            <HtmlDialog className="edit-anime">
                <div className="top-data">
                    <h1>{block ? 'Заблокировать' : 'Разблокировать'} пользователя {nickName}?</h1>
                    <div className="content" style="display:block;">
                        <p>Вы собираетесь заблокировать пользователя {nickName}{where}. Пожалуйста, укажите причину и
                            длительность блокировки:</p>
                        <p>Длительность блокировки:
                            <span className="inputs" style={{display: 'flex', alignItems: "center"}}>
                                <input type="number" value={0} ref={days} className="bordered" style={{width: "80px"}}/>д.
                                <input type="number" placeholder="ч" value={0} ref={hours} style={{width: '80px'}} className="bordered"/>:
                                <input type="number" placeholder="м" value={10} ref={minutes} style={{width: '80px'}} className="bordered"/>:
                                <input type="number" placeholder="c" value={0} ref={seconds} style={{width: '80px'}} className="bordered"/>
                            </span>
                        </p>
                        <textarea className="message-text" placeholder="Комментарий (обязательно)"/>
                    </div>
                </div>
                <div className="bottom-buttons">
                    <div className="cancel-button main-button neutral">Отмена</div>
                    <div className="save-button main-button attention" onClick={onSaveBtnClick}>Заблокировать</div>
                </div>
            </HtmlDialog>
        );
        document.body.appendChild(dialog); //.appendTo('body');
        //@ts-ignore
        // $(dialog).find('.lock-long').slimSelect();

        function onSaveBtnClick() {
            const secondsTotal =  +seconds.value!.value! + (+minutes.value!.value*60) + (+hours.value!.value*3600) + (+days.value!.value* 3600 * 24);
            resolve([
                Math.floor(Math.max(secondsTotal, 0)),
                $(dialog).find(".message-text").val()! as string
            ]);
            //@ts-ignore
            dialog.close();

        }
    })

}

export function askQuestion(title: string, description: string | Node, okButton: string = 'Отклонить', placeHolder: string = 'Комментарий (обязательно)'): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const $dialog = $(
            <HtmlDialog>
                <div className="top-data">
                    <h1>{title}</h1>
                    <div className="content" style="display:block;">
                        <p>{description}</p>
                        <textarea className="message-text bordered" placeholder={placeHolder}/>
                    </div>
                </div>
                <div className="bottom-buttons">
                    <div className="cancel-button main-button neutral bordered"
                         onClick={() => reject("Canceled")}>Отмена
                    </div>
                    <div className="save-button main-button attention bordered" onClick={() => {
                        resolve($dialog.find(".message-text").val()! as string);
                        $dialog[0].close();
                    }}>{okButton}</div>
                </div>

            </HtmlDialog>
        )
            .appendTo('body');

    })
}

export function incrementCounter(selector: string) {
    const btn = $(selector);
    btn.attr('data-not-viewed', +(btn.attr('data-not-viewed') || 0) + 1);
}

export function playAudio(name: keyof typeof audios) {
    if (localStorage.muted === 'true') return;
    const audio: HTMLAudioElement = audios[name];
    audio.pause();
    audio.currentTime = 0;
    audio.play().catch(console.error);
}

export function placeCaretAtEnd(el: HTMLElement) {
    el.focus();
    if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
    } else if ('createTextRange' in document.body) {
        // @ts-ignore
        const textRange = document.body['createTextRange']();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
    el.scrollLeft = el.scrollWidth;
}

export function htmlToBb(text: string) {
    const map: { [k: string]: string } = {
        'b': 'ж',
        'i': 'к',
        'u': 'п',
        's': 'з',
        'strike': 'з',
        'nick': 'ник',
    };
    text = stripHtml(text)
        .replace(/<(\/?)(nick|strike|[bius])( .+?)?>/g, (match: string, e1: string, e2: string) => {
            return '[' + e1 + map[e2] + ']';
        }).replace(/<button.*?>(.+?)<\/button><spoiler.*?>((?:.|\n)*?)<\/spoiler>/g, '[спойлер="$1"]$2[/спойлер]');
    text = text
        .replaceAll(/<div><\/div>/g, '')
        .replaceAll(/<div>/g, '\n')
        .replaceAll(/<\/div>/g, '')
        .replaceAll(/<br\/?>/g, '\n');
    let div = document.createElement("div");
    div.innerHTML = text;
    text = div.textContent || div.innerText || "";
    return text;
}

export function spoilerToBb(text: string) {
    text = stripHtml(text)
        .replace(/<button.*?>(.+?)<\/button><spoiler.*?>((?:.|\n)*?)<\/spoiler>/g, '[спойлер="$1"]$2[/спойлер]');
    return text;
}

export function removeEmptybb(message: string) {
    let text = message;
    while (/\[ж]\s*?\[\/ж]|\[к]\s*?\[\/к]|\[п]\s*?\[\/п]|\[з]\s*?\[\/з]|\[спойлер(="[^"]*?")?]\s*?\[\/спойлер]/.test(text)) {
        const r = /\[ж]\s*?\[\/ж]|\[к]\s*?\[\/к]|\[п]\s*?\[\/п]|\[з]\s*?\[\/з]|\[спойлер(="[^"]*?")?]\s*?\[\/спойлер]/g;
        text = text.replace(r, '');
    }
    return text;
}

export function bbToHtml(text: string) {
    const map: { [k: string]: string } = {
        'ж': 'b',
        'к': 'i',
        'п': 'u',
        'з': 's',
    };
    let editable = '';
    if (mobileOperatingSystem !== 'Android') {
        editable = ' contenteditable="false"'
    }
    text = text
        .replace(/\[ник](.+?)\[\/ник]/gm, function (match, m1) {
            let c = 'nick-label';
            if (m1 === login) {
                c += ' my-nick';
            }
            return `<nick class="${c}"${editable}>${m1}</nick> `;
        })
        .replace(/\[(\/?)([жкпз])]/g, function (match, e1, e2) {
            return '<' + e1 + map[e2] + '>';
        }).replace(/\[спойлер(?:=(?:&quot;|")(.+?)(?:&quot;|"))?]((?:.|\n)+?)\[\/спойлер]/g, function (match, e1, e2) {
            if (!e1) e1 = 'Спойлер!';
            return `<button class="spoiler-button bordered">${e1}</button><spoiler>${e2}</spoiler>`;
        }).replace(/\[\/?спойлер(=.+?)?]/g, '')
        .replace(/&nbsp;/g, ' ');
    return stripHtml(text);
}

export function stripHtml(html: string) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.innerHTML || "";
}

export function formatWord(number: number, one: string, two: string, five: string) {
    const cases = [2, 0, 1, 1, 1, 2];
    if (number % 100 > 4 && number % 100 < 20) return five;
    switch (Math.min(number % 10, 5)) {
        case 0:
        case 5:
            return five;
        case 1:
            return one;
    }
    return two;
    // return [one, two, five][cases[]];
}

export function numberToBgImage(number: number) {
    if (supportedImageFormats.webp) return number + '.webp';
    else if (number === 24 || number === 35) return number + '.gif';
    return number + '.jpg';

}

export function showNotice(
    message: string | Node,
    caption: string = 'Новое уведомление',
    level?: 'error' | '' | 'normal' | 'success',
    isHtml: boolean = false,
    onClick?: () => any
) {
    if (!message) return;
    let last = $(
        <div className="notice-slot" onClick={() => {
            onClick && onClick();
            last.css('transition', 'all .3s')
                .css('max-height', '0')
                .css('opacity', '0')
                .css('margin', '0');
            setTimeout(() => void last.remove(), 300)
        }}>
            <div className={`notice-popup ${level || 'normal'}`}>
                <div className="n-caption">{isHtml ? createElementFromHTML(caption) : caption}</div>
                <div
                    className="n-body">{isHtml && typeof message === 'string' ? createElementFromHTML(message) : message}</div>
            </div>
        </div>
    )
        .appendTo('.notice-container')
    last.css('max-height', last.children().outerHeight() + "px")
        .delay(6000)
        .queue(function (next) {
            if (parseInt(last.css('opacity')) == 1) {
                last.css('pointer-events', 'none')
                    .css('opacity', '0')
                    .css('margin-bottom', last.children().outerHeight() + "px");
                next();
            }
        }).delay(1000).queue(() => last.remove())
}

(window as any).showNotice = showNotice;

export class HtmlDialog extends JSXElement<{
    className?: string,
    OnClose?: () => any,
    ref?: RefObject<HTMLDivElement>
}> {
    private readonly animateElement: JSX.RefObject = {};
    private removed: boolean = false;

    render() {
        document.body.style.overflowY = 'hidden';
        const ans: HTMLElement & { close: () => any } = (
            <div className="dialog-bg"
                 style={{background: 'transparent'}}
                 {...(this.props.ref ? {ref: this.props.ref} : {})}
            >
                <div className={'dialog' + (this.props.className ? ' ' + this.props.className : '')}
                     style={{transform: 'translateY(-100vh)'}} ref={this.animateElement}>
                    {...this.content}
                </div>
            </div>
        );

        ans.close = this.close;
        $(ans).data('close-event', ans.close)
        setTimeout(() => this.animate(true));
        return ans;
    }

    private animate = (show: boolean) => {
        this.animateElement.value!.style.transform = show ? '' : 'translateY(-100vh)';
        this.element.style.background = show ? '' : 'transparent';
    }
    private close = (invokeCloseEvent: boolean = true) => {
        if (this.removed) return;
        this.removed = true;
        this.animate(false);
        document.body.style.overflowY = '';
        setTimeout(() => {
            void this.element.remove();
        }, 300);
        if (invokeCloseEvent)
            this.props.OnClose?.();
    }
}

export function createElementFromHTML(htmlString: string) {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    // Change this to div.childNodes to support multiple top-level nodes.
    return div.childNodes;
}

export async function fetchServer<T>(uri: string, method: 'POST' | 'GET' | 'DELETE' | 'HEAD' | 'OPTIONS' | 'PATCH' | 'PUT' = 'GET', init?: RequestInit & {
    retryCount?: number
}): Promise<T> {
    init ??= {};
    init.method ??= method;
    init.headers ??= {};
    // @ts-ignore
    init.headers['accept'] ??= await getAcceptHeader();
    const responseObj = await fetch(uri, init);
    if (method === 'HEAD') {
        if (responseObj.status === 200) return {response: true} as ServerResponse as T;
        else if (responseObj.status === 404)
            throw new YummyServerError("Not found", 404);
        throw new YummyServerError(responseObj.statusText, responseObj.status);
    }
    //Rate limit API handler - retry 3 times
    if (responseObj.status === 429) {
        init.retryCount ??= 0;
        init.retryCount++;
        if (init.retryCount <= 3) {
            await new Promise(r => setTimeout(r, 5000));
            return fetchServer(uri, method, init);
        }
    }
    let response: ServerResponse;
    let content = responseObj.headers.get('content-type') ?? '';
    if (content.includes('application/xml') || content.includes('text/xml')) {
        throw new YummyServerError("Xml response is not yet supported!");
    } else if (content.includes('json5')) {
        //@ts-ignore
        response = JSON5.parse(await responseObj.text())
    } else {
        response = await responseObj.json() as ServerResponse;
    }

    if (response.error) {
        throw new YummyServerError(response.error, response.error_code, response.error_title ?? 'Ошибка', response.error_name ?? '', response.sub_error_code);

    }
    return response as T;
}

export function handleFetchError(error: any) {
    //Client error - params/flood/ect.
    if (error instanceof YummyServerError) {
        showNotice(error.message, error.title, 'error');
    }
    //Fetch failed error
    else if (error instanceof TypeError) {
        showNotice('Нет доступа к серверу.\nПроверьте интернет соединение.', 'Вы офлайн :(', 'error');
    }
    //JSON decode error
    else if (error instanceof SyntaxError) {
        showNotice('Неизвестная ошибка сервера...\nПопробуйте ещё раз или напишите нам.', 'Упс... Что-то пошло не так...', 'error');
    }
    //Maybe some function threw string? (but actually it shouldn't -_-)
    else if (typeof error === "string") {
        showNotice(error, 'Ошибка', 'error');
    } else {
        showNotice('Произошла неизвестная ошибка.\nПопробуйте ещё раз или напишите нам.', 'Опана! Походу я сломался :(  ', 'error');
    }
    console.error(error);
}

const neonUsers = [1,];
$(() => {//Neon:
    let c = 0;
    if (page_type === 'user' && neonUsers.includes(page_id!))
        setInterval(() => $('.profile-bg-img')[0].style.setProperty('--shadow-color', (c++ < 360 ? c : (c = 0)) + ''), 10);
})

export async function arrayBufferToBase64(buffer: ArrayBuffer): Promise<string> {
    const blob = new Blob([buffer], {type: 'application/octet-binary'}),
        reader = new FileReader();
    return new Promise<string>((resolve, reject) => {
        reader.onload = function (evt) {
            const dataurl = evt.target!.result as string;
            resolve(dataurl!.substring(dataurl!.indexOf(',') + 1));
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export async function uploadImage(image: any): Promise<string> {
    const formData = new FormData();
    if (image.type) formData.append('type', image.type);
    formData.append('image', image);
    const response = await fetchServer<{ success: boolean; data: { link: string; }, error?: any }>(
        'https://api.imgur.com/3/image', 'POST', {
            headers: {
                Accept: 'application/json',
                Authorization: 'Client-ID a3476bf2abe3f3c',
            },
            body: formData
        }
    );
    if (!response.success) throw new YummyUploadImageError("Ошибка загрузки фотографии: " + response.error, response);
    return response.data.link;
}

export async function fileToBlob(file: File) {
    return new Promise<Blob>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (event) {
            const blob = new Blob([event!.target!.result!], {type: file.type});
            resolve(blob);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

export const showDialogRecaptcha = () => new Promise<string>(async function (success, reject) {
    const $dialog = $(<div className="dialog-bg">
        <div className='dialog edit-anime'>
            <div className="top-data">
                <h1>Пройдите капчу</h1>
                <div className="content" style={{height: '90px', textAlign: "center"}}>
                    <div id="h-captcha" data-sitekey={$('#hcaptcha-key').attr('content')}
                         data-error-callback="hcaptchaCallbackError"
                         data-callback="hcaptchaCallback"/>
                </div>
            </div>
            <div className="bottom-buttons">
                <div className="cancel-button main-button neutral">Отмена</div>
            </div>
        </div>
    </div>)
        .data('close-event', closeDialog)
        .appendTo('body');
    //@ts-ignore
    window['hcaptcha'].render('h-captcha', {sitekey: $('#hcaptcha-key').attr('content')});
    //@ts-ignore
    window['hcaptchaCallback'] = (token) => {
        console.log(`Captcha had been solved : ${token}`);
        closeDialog(false);
        success(token);
    }
    //@ts-ignore
    window['hcaptchaCallbackError'] = (e) => {
        console.log(`Captcha had been rejected : ${e}`);
        $dialog.remove();
        reject(e);
    };

    function closeDialog(r = true) {
        $dialog.remove();
        if (r) reject('Canceled');
    }
})
    .finally(() => {
        //@ts-ignore
        delete window['hcaptchaCallback']
        //@ts-ignore
        delete window['hcaptchaCallbackError']
    })

export function showAskDialog(question: HTMLElement | string, description: HTMLElement | string, buttonOk: string = 'OK', buttonCancel: string = 'Отмена'): Promise<boolean> {

    return new Promise(resolve => {
        const $dialog: HTMLElement & { close: (invokeCloseEvent?: boolean) => any } = (
            <HtmlDialog OnClose={() => resolve(false)} className="edit-anime">
                <div className="top-data">
                    <h1>{typeof question === 'string' ? createElementFromHTML(question) : question}</h1>
                    <p>{typeof description === 'string' ? createElementFromHTML(description) : description}</p>
                </div>
                <div className="bottom-buttons">
                    <div className="cancel-button close-dialog main-button neutral bordered">{buttonCancel}</div>
                    <div className="ok-btn main-button bordered" onClick={() => {
                        resolve(true);
                        $dialog.close(false)
                    }}>{buttonOk}</div>
                </div>
            </HtmlDialog>
        );
        document.body.appendChild($dialog);

    });
}

const audios = {
    notification: new Audio("/js/notification.mp3")
} as const;
for (let a of Object.values(audios)) a.autoplay = false;

export interface QRCodeST {
    _options: RequiredOptions;
    _container?: HTMLElement;
    _canvas?: QRCanvas;
    _svg?: QRSVG;
    _qr?: QRCode;
    _canvasDrawingPromise?: Promise<void>;
    _svgDrawingPromise?: Promise<void>;

    constructor(options?: Partial<Options>): any;

    /**@static*/
    _clearContainer(container?: HTMLElement): void;

    _getQRStylingElement(extension?: Extension): Promise<QRCanvas | QRSVG>;

    update(options?: Partial<Options>): void;

    append(container?: HTMLElement): void;

    getRawData(extension?: Extension): Promise<Blob | null>;

    download(downloadOptions?: Partial<DownloadOptions> | string): Promise<void>;
}

export function openDropList(block: JQuery) {
    $('.category-list > li').css('z-index.php', '');
    block.parents('li').css('z-index.php', '4');
    var list = block.addClass('open').find('.category-list-inner');
    list.show().css({height: list[0].scrollHeight});
    block.find('.drop-icon').addClass('open');
    setTimeout(function () {
        block.removeClass('block');
        list.css({height: 'auto'});
    }, 300);
}

export function closeDropList(block: JQuery) {
    var list = block.find('.category-list-inner');
    list.css({height: list[0].scrollHeight});
    setTimeout(function () {
        list.css({height: ''});
    }, 0);
    block.find('.drop-icon').removeClass('open');
    setTimeout(function () {
        list.hide();
        block.removeClass('block open')
    }, 300);
}


export function getQueryMap<T>(query: string) {
    if (typeof query != 'string') {
        return {} as T;
    }

    const map: { [k: string]: any } = {};

    // map the hit query into a proper object
    //@ts-ignore
    query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match: string, key, value): string {
        key = decodeURIComponent(key);
        // let [key, value] = args;
        if (key.endsWith('[]')) {
            key = key.replace('[]', '');
            if (!(key in map))
                map[key] = [];
        }
        if (/^-?\d+$/.test(value)) value = +value;
        if (typeof value === 'string' && !value) return '';
        if (key in map) {

            // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
            if (!Array.isArray(map[key])) {
                map[key] = [map[key]];
            }
            map[key].push(value);
        } else {
            // put the value into the map
            map[key] = value;
        }
        return '';
    });
    return map as T;
}


export interface IImg {
    big: string;
    small: string;
}

export function formatYoutubeLink(link: string): { src: string; imgs?: IImg } | null {
    if (!link) return null;
    if (!link.startsWith('http://') && !link.startsWith('https://'))
        link = 'https://' + link;
    let url: URL;
    try {
        url = new URL(link);
    } catch (e) {
        showNotice('Неправильный формат ссылки. Пожалуйста, скопируйте ссылку напрямую с ролика на ютубе', 'Ошибка', 'error');
        return null;
    }
    if (url.hostname === 'youtu.be') return {
        src: `https://youtube.com/embed${url.pathname}?enablejsapi=1`,
        imgs: getImgs(url.pathname.replaceAll('/', ''))
    };
    let idParam = url.searchParams.get('v');
    if (!idParam) {
        if (url.pathname.startsWith('/embed/'))
            idParam = url.pathname.split('/')[2]!;
    }
    if (idParam) return {src: `https://youtube.com/embed/${idParam}?enablejsapi=1`, imgs: getImgs(idParam)};
    return {src: url.toString()};
}

function getImgs(youtubeId: string): IImg {
    return {
        big: `https://i3.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
        small: `https://i3.ytimg.com/vi/${youtubeId}/mqdefault.jpg`
    }
}


export async function importALL(...links: string[]): Promise<any> {
    const promises = links.map(link =>
        new Promise((resolve, reject) => {
            const script = (<script src={link} onLoad={resolve} onError={reject}/>);
            document.head.appendChild(script);
        })
    );
    return Promise.all(promises);

}
